<template>
  <BaseVeeForm :action="submitForm" v-slot="{ isPending, isRejected, invalid }">
    <BaseCard>
      <BaseCardBody>
        <div class="space-y-6">
          <ValidationProvider rules="required" name="first name" tag="div" vid="firstName">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>First name</BaseFormLabel>
                <BaseFormInput
                  type="firstName"
                  v-model="formData.firstName"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider rules="required" name="last name" tag="div" vid="lastName">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>Last name</BaseFormLabel>
                <BaseFormInput v-model="formData.lastName" :disabled="isPending" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider rules="required" name="email" tag="div" vid="email">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>Email address</BaseFormLabel>
                <BaseFormInput type="email" v-model="formData.email" :disabled="isPending" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider
            rules="required|confirmed:password_confirmation"
            name="password"
            tag="div"
            vid="password"
          >
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel>Password</BaseFormLabel>
                <BaseFormInput type="password" v-model="formData.password" :disabled="isPending" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            name="password confirmation"
            tag="div"
            vid="password_confirmation"
          >
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="password_confirmation"> Confirm password </BaseFormLabel>
                <BaseFormInput
                  id="password_confirmation"
                  type="password"
                  v-model="formData.password_confirmation"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
      </BaseCardBody>
      <BaseCardBody>
        <BaseButton primary class="w-full" :disabled="invalid || isPending || isRejected">
          Create user
        </BaseButton>
      </BaseCardBody>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'CreateUserForm',

  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
    };
  },

  methods: {
    async submitForm() {
      const {
        $store: { dispatch },
        formData,
      } = this;

      try {
        const { userId } = await dispatch({
          type: 'admin/users/storeUser',
          formData,
        });

        this.$emit('success', userId);

        return Promise.resolve(userId);
      } catch (error) {
        this.$emit('failure', error);
        return Promise.reject(error);
      }
    },
  },
};
</script>
